const initialState = false ;

function loader(state = initialState, action){
    switch(action.type){
        
        case 'SET_LOADER' : 
            state = action.data;
            return state;
       
        default : return state;

    }

}

export default loader;